import { Card, CardContent } from "@mui/material";
import Typography from "@mui/material/Typography"; // MUI Typography
import { styled } from "@mui/material/styles";
import React from "react";
import Fonts from "../../../Config/Fonts";
import Colors from "../../../theme/Colors";

const TopCardSection = ({ cardTopText, cardValue, icons }) => {
  return (
    <StyledCard>
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* Styled Image with hover effect */}
        <StyledImg src={icons} alt="icons" />

        {/* Typography for Card Top Text */}
        <Typography
          variant="h5"
          className="hover-text"
          component="div"
          sx={{
            fontSize: 16,
            fontWeight: 500,
            fontFamily: Fonts.Poppins,
            color: Colors.textLightColor,
            transition: "color 0.3s ease-in-out",
            marginBottom: "10px",
          }}
        >
          {cardTopText}
        </Typography>

        {/* Typography for Card Value */}
        <Typography
          variant="h5"
          className="hover-text"
          component="div"
          sx={{
            fontSize: 20,
            fontWeight: 600,
            fontFamily: Fonts.Poppins,
            color: Colors.lightBlackColor,
            transition: "color 0.3s ease-in-out",
          }}
        >
          {cardValue || '0'}
        </Typography>
      </CardContent>
    </StyledCard>
  );
};

// Styled Card component with hover effect
const StyledCard = styled(Card)(() => ({
  width: "15%",
  height: "16vh",
  backgroundColor: Colors.white,
  borderRadius: 8,
  border: "0.1px solid #d3d3d3",
  display: "flex",
  flexDirection: "column",
  margin: "0px 10px 30px 10px",
  transition: "all 0.3s ease-in-out",
}));

// Styled Image component with hover effect
const StyledImg = styled("img")(() => ({
  height: 35,
  width: 35,
  marginTop: "5px",
  marginBottom: "10px",
}));

export default TopCardSection;
